import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import*as echarts from 'echarts'



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
//require('videojs-contrib-hls/dist/videojs-contrib-hls.js')

Vue.use(ElementUI);

Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
